import { render, staticRenderFns } from "./AddCampaign.vue?vue&type=template&id=51048684&scoped=true&"
import script from "./AddCampaign.vue?vue&type=script&lang=js&"
export * from "./AddCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaign.vue?vue&type=style&index=0&id=51048684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51048684",
  null
  
)

export default component.exports